/**
 * O `runAtual` do store FIXO, recortado para UMA conversa.
 *
 * ★ [owner, 21/09/2026] *"o chip '● Falhou' aparece nas outras abas para um
 * run que eu cancelei"*. Os canais do Modo Agente (`runAtual`,
 * `propostasAbertas`, `reconectando`) moram no store fixo `aawz-intelligence-v2`
 * — produtor e leitores concordam (CLAUDE.md, "o `plano` é o ÚNICO canal do
 * agente que saiu do store fixo") —, mas desde as conversas em ABAS há N
 * `<ViewChat>` lendo o mesmo store: o run da aba A pintava o chip da aba B,
 * com o estado de um turno que a B nunca viu.
 *
 * O recorte é pelo `id_conversa` que o run passou a carregar
 * (`SET_RUN_ATUAL`): run de OUTRA conversa é como se não houvesse run. Run
 * SEM `id_conversa` (o canal legado do `start`, sem conversa fixada) continua
 * valendo para todo mundo — é o comportamento de antes, e recusá-lo apagaria
 * o chip da própria aba dona do run.
 *
 * ★ [review #2364] O leitor SEM conversa (a aba em BRANCO, aberta pelo "+")
 * também não vê o run que carrega dona: era o outro caminho por onde o chip
 * "Falhou" da aba A chegava a uma aba que nunca viu aquele turno. A aba dona
 * nunca lê sem conversa: os três produtores fixam `selectedConversation`
 * ANTES de `setRunAtual` (`_fixarConversaDoRun`, `_fixarConversaERunDoStart`
 * e `runAtual(idConversa)`), então quando o run existe a conversa já existe.
 *
 * ⚠️ O que isto NÃO resolve: dois runs CONCORRENTES em duas abas disputam o
 * MESMO slot do store fixo (o último `setRunAtual` vence). O recorte é do
 * leitor; o desenho certo é o run morar no namespace da conversa, como o
 * `plano` já mora — ver "o run é recortado por conversa" no CLAUDE.md.
 *
 * @param {?Object} runAtual O getter `aawz-intelligence-v2/runAtual`.
 * @param {?string} idConversa A conversa da superfície que lê.
 * @returns {?Object} O run, ou `null` quando ele é de outra conversa.
 * @example runDaConversa({ id_run: 'r', id_conversa: 'a' }, 'b') // → null
 */
export function runDaConversa(runAtual, idConversa) {
  if (!runAtual) return null
  const dona = runAtual.id_conversa
  if (!dona) return runAtual
  return idConversa && dona === idConversa ? runAtual : null
}
